import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {
    fetchGetSelfStudyBooks,
    getApplicantSelfStudyBooksData,
    loadingApplicantSelfStudyBooks
} from "../../../reducers/applicantSelfStudy/applicantSelfStudyBooks";
import SelfStudyList from "./SelfStudyList";
import {MODAL_REMOVE_SELF_STUDY_BOOK, showModal} from "../../../reducers/common/activeModal";
import {onUpdateSelfStudyBookFromList} from "../../../reducers/applicantSelfStudy/applicantSelfStudyBook";

const mapStateToProps = state => {
    return {
        loading: loadingApplicantSelfStudyBooks(state),
        translation: getTranslation(state),
        data: getApplicantSelfStudyBooksData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetSelfStudyBooks());
        },
        onBookRemove: () => dispatch(showModal({modalKey: MODAL_REMOVE_SELF_STUDY_BOOK})),
        onBookUpdate: (id, data) => dispatch(onUpdateSelfStudyBookFromList(id, data))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SelfStudyList);



// WEBPACK FOOTER //
// ./src/components/selfStudyManagement/selfStudyList/SelfStudyList.container.js